import type { FaireProductEntity } from "../../entity_types/product";

export const p_ynadzkkz7x: FaireProductEntity = {
  token: "p_ynadzkkz7x",
  type: "product",
  name: "The Cr\u00e8me Shop Klean Beauty\u2122 Vegan Retinol Face Sheet Mask",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/15a50e2504b86434a11f399ef2b8a7984dd951f2d6d23aa68731801dc51a761e.png",
  priceDollars: 0.55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
